import PressReleases from "../components/PressReleases";

function PressReleasesPage() {
  return <PressReleases />;
}
export default PressReleasesPage;
